import TrackedBridgeComponent from "../lib/tracked_bridge_component"
import { fetchJson } from "../lib/fetch_json"

export default class extends TrackedBridgeComponent {
  static component = "google_sign_in"
  static targets = ["errorMessage"]
  static values = {
    url: String,
    noAccountError: String,
    genericError: String
  }

  signIn() {
    this.hideError()
    this.send("connect", {}, (message) => this.handleBridgeReply(message.data))
  }

  handleBridgeReply(data) {
    if (data.error) {
      this.handleBridgeError(data.error)
      return
    }

    this.submitToken(data.idToken, data.nonce)
  }

  handleBridgeError(errorCode) {
    if (errorCode === "cancelled") return
    if (errorCode === "no_credential") {
      this.showError(this.noAccountErrorValue)
      return
    }
    this.showError(this.genericErrorValue)
  }

  async submitToken(idToken, nonce) {
    try {
      const data = await fetchJson(this.urlValue, { method: "POST", body: { idToken, nonce } })
      const destination = new URL(data.redirectTo || window.location.pathname, window.location.origin).href
      Turbo.visit(destination)
    } catch (e) {
      console.error("[google-native-sign-in] submitToken failed:", e)
      this.showError(this.genericErrorValue)
    }
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove("hidden")
  }

  hideError() {
    this.errorMessageTarget.classList.add("hidden")
  }
}
